import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import {
	AlertComponent,
	AuthLayoutComponent,
	ButtonComponent,
	FormGroupComponent,
	InputComponent,
} from '@tecalisdev/infinity';
import { environment } from '../../../../environments/environment';
import { ReactiveFormsService } from '../../../shared/services/reactive-forms.service';
import { LoginHelperService } from '../../services/login-helper.service';
import { LanguageSelectorComponent } from '../../../core/components/language-selector/language-selector.component';

@Component({
	selector: 'app-login',
	imports: [
		ReactiveFormsModule,
		TranslatePipe,
		AuthLayoutComponent,
		AlertComponent,
		FormGroupComponent,
		InputComponent,
		ButtonComponent,
		FormGroupComponent,
		AlertComponent,
		LanguageSelectorComponent,
	],
	templateUrl: './login.component.html',
	styleUrl: './login.component.scss',
})
export class LoginComponent {
	public reactiveFormsService = inject(ReactiveFormsService);
	private activatedRoute = inject(ActivatedRoute);
	private loginHelper = inject(LoginHelperService);
	private router = inject(Router);

	public showForm = false;
	public showConfirmEmail = false;
	public form: FormGroup = new FormGroup({
		email: new FormControl('', Validators.required),
		password: new FormControl('', Validators.required),
	});
	public alertMsg: string = '';

	constructor() {
		this.activatedRoute.queryParams.subscribe((params) => {
			if (params['info']) {
				if (!environment.production) this.showForm = params['info'] === 'manual_login';
				this.showConfirmEmail = params['info'] === 'confirm_email';
				return;
			}

			this.router.navigate(['/']);
		});
	}

	public login(): void {
		// Si es producción, no permitir login manual
		if (environment.production) return;

		this.form.markAllAsTouched();
		if (!this.form.valid) return;

		this.loginHelper.loginStandard(this.form.value).catch((error) => {
			this.alertMsg = error.error?.message;
		});
	}
}
